// SUNDAY BATCH · agent B (D-1 / D-2 / D-3 / D-5 / D-6 / D-8 / D-9) — firm dashboard strings, EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file); keys under the dashboard's `fd` block.
export const I18N_SBB = {
  en: {
    fd: {
      minutes: "{n} min",                                         // D-6: below 0.1 h
      tiles: { rpOpenOf: "{n} open of {total}" },                 // D-1
      portfolio: { rpHint: "total / resolved / unresolved" },     // D-1
      billing: {
        feeNotSet: "Fee not set",                                 // D-3
        feeNotSetN: "Fee not set for {n} engagements",            // D-3 (currency total)
        incomplete: "Incomplete - {h} without rate",              // D-2
        aiRateNotSet: "rate not set",                             // D-8
        aiRate: "USD {r} per unit",                               // D-8
        aiTotal: "Firm AI total (engagements + firm-level)",      // D-9
        aiNotListed: "incl. {x} on engagements no longer listed", // D-9 (binned / deleted engagements)
      },
      staff: { total: "Total", scrollHint: "Scroll sideways inside the table to see every engagement." },   // D-5
    },
  },
  ar: {
    fd: {
      minutes: "{n} دقيقة",
      tiles: { rpOpenOf: "{n} مفتوحة من {total}" },
      portfolio: { rpHint: "الإجمالي / المحلولة / غير المحلولة" },
      billing: {
        feeNotSet: "لم تُحدّد الأتعاب",
        feeNotSetN: "لم تُحدّد الأتعاب لـ {n} ارتباطات",
        incomplete: "غير مكتمل - {h} بدون سعر",
        aiRateNotSet: "لم يُحدّد السعر",
        aiRate: "{r} دولار لكل وحدة",
        aiTotal: "إجمالي الذكاء الاصطناعي للمكتب (الارتباطات + مستوى المكتب)",
        aiNotListed: "منها {x} على ارتباطات لم تعد معروضة",
      },
      staff: { total: "الإجمالي", scrollHint: "مرّر أفقيًا داخل الجدول لرؤية كل الارتباطات." },
    },
  },
};

export default I18N_SBB;
